module.exports = __webpack_public_path__ + "img/course-cover03.708276db.png";